import React from "react";

import { useIsLandingPage } from "@app/context/use-entity";
import { useAppContext } from "@app/helpers/hooks";

import { AccountItemLayout } from "../account-item-layout";

interface Props {
  hideIcon?: boolean;
}

export const SignInLink: React.FC<Props> = ({ hideIcon }) => {
  const { translator, urlBuilder } = useAppContext();
  const is_landing_page = useIsLandingPage();

  return (
    <AccountItemLayout
      className="footer-signin-button"
      link={is_landing_page ? urlBuilder.accountSignin() : undefined}
      label={translator.t("!layout.header.signin")}
      hideIcon={hideIcon}
    />
  );
};
